import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppComponent } from './app.component';

import { TabsModule } from 'ng2-bootstrap/tabs';
import { NAV_DROPDOWN_DIRECTIVES } from './shared/nav-dropdown.directive';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!

// Routing Module
import { AppRoutingModule } from './app.routing';

// Layouts
// import { FullLayoutComponent } from './layouts/full-layout.component';
import { SimpleLayoutComponent } from './layouts/simple-layout.component';
import { AdminLayoutComponent } from './layouts/admin-layout.component';
import { RecruiterLayoutComponent } from './layouts/recruiter-layout.component';
//services
import { AuthenticationService } from './services/authentication.service';
import { RecruiterAuthenticationService } from './services/recruiter-authentication.service';
import { UserService } from './services/user.service';
import { TalentService } from './services/talent.service';
import { TalentPoolService } from './services/talentpool.service';
import { P404Component } from './pages/404.component';
import { P403Component } from './pages/403.component';

import { UserRegistrationService, 
         UserLoginService, 
         UserParametersService, 
         UserManageService, 
         CognitoUtil } from "./services/cognito/cognito.service";
import { JwtHelper } from 'angular2-jwt';

import { AuthGuard } from './auth-guard.service';

import { GmapLocation } from './library/location-map';

import { AdminAuthenticationService } from './services/admin-authentication.service';
import { GuestAuthenticationService } from './services/guest-authentication.service';
import { GuestAuthGuard } from './guest-auth-guard.service';
import { FileUploadService } from './services/file-upload.service';
import { NguUtilityModule } from './library/ngu-utility/ngu-utility.module';
import { CognitoTokensService } from './services/cognito/cognito-tokens.service';
import { DashboardComponent } from './recruiter/dashboard/dashboard.component';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpModule,
    NguUtilityModule

  ],
  declarations: [
    AppComponent,
    // FullLayoutComponent,
    SimpleLayoutComponent,
    AdminLayoutComponent,
    NAV_DROPDOWN_DIRECTIVES,
    P404Component,
    P403Component,
    GmapLocation,
    RecruiterLayoutComponent     
  ],
  providers: [{
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    AuthenticationService,
    UserService,
    TalentService,
    TalentPoolService,
    AuthGuard,
    GmapLocation,
    RecruiterAuthenticationService,
    CognitoUtil,
    UserRegistrationService,
    UserLoginService,
    UserParametersService,
    UserManageService,
    JwtHelper,
    AdminAuthenticationService,
    GuestAuthenticationService,
    GuestAuthGuard,
    FileUploadService,
    CognitoTokensService,
    DashboardComponent
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts